export { OpsGenieIcon } from './old-icon';
export { OpsgenieIcon } from './new-icon';
export { OpsGenieLogo } from './old-logo';
export { OpsgenieLogo } from './new-logo';
export { OpsGenieWordmark } from './old-wordmark';
export { OpsgenieWordmark } from './new-wordmark';